import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title = 'AF Pictures - Distribución cinematográfica profesional',
  description = 'Empresa de distribución cinematográfica especializada en la promoción y distribución de películas. Distribuidora profesional de cine independiente, largometrajes y cortometrajes.',
  keywords = 'distribución cinematográfica, distribuidora de cine, películas independientes, distribución de largometrajes, cine español, distribución audiovisual',
  image = 'https://afpictures.com/img/af-pictures-og.jpg',
  url = 'https://afpictures.com',
  type = 'website',
  structuredData = null,
  canonical = null,
  noindex = false,
  lang = 'es'
}) => {
  const siteTitle = 'AF Pictures';
  const fullTitle = title === siteTitle ? title : `${title} | ${siteTitle}`;
  const canonicalUrl = canonical || url;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Robots */}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="es_ES" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional Meta Tags */}
      <meta name="author" content="AF Pictures" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#000000" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
